import type { ChartData } from "../types/analytics"

const q = (v: unknown): string => `"${String(v ?? "").replace(/"/g, '""')}"`

export const downloadCsv = (rows: (string | number | null | undefined)[][], filename: string): void => {
  const csv  = rows.map(r => r.map(q).join(",")).join("\n")
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" })
  const url  = URL.createObjectURL(blob)
  const a    = document.createElement("a")
  a.href     = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export const downloadChartAsPng = (wrapEl: HTMLElement | null, filename: string): void => {
  const canvas = wrapEl?.querySelector<HTMLCanvasElement>("canvas")
  if (!canvas) return
  const copy = document.createElement("canvas")
  copy.width  = canvas.width
  copy.height = canvas.height
  const ctx = copy.getContext("2d")
  if (!ctx) return
  ctx.fillStyle = "#ffffff"
  ctx.fillRect(0, 0, copy.width, copy.height)
  ctx.drawImage(canvas, 0, 0)
  const a    = document.createElement("a")
  a.href     = copy.toDataURL("image/png")
  a.download = filename
  a.click()
}

export const downloadElementAsPng = async (el: HTMLElement | null, filename: string): Promise<void> => {
  if (!el) return
  const { default: html2canvas } = await import("html2canvas")
  const canvas = await html2canvas(el, { backgroundColor: "#ffffff", scale: 2 })
  const a    = document.createElement("a")
  a.href     = canvas.toDataURL("image/png")
  a.download = filename
  a.click()
}

export const chartDataToCsvRows = (data: ChartData): (string | number | null)[][] => {
  const header = ["ラベル", ...data.datasets.map(ds => ds.label ?? "値")]
  const body   = data.labels.map((label, i) =>
    [label, ...data.datasets.map(ds => ds.data[i] ?? null)]
  )
  return [header, ...body]
}

export const todayStr = (): string => new Date().toISOString().split("T")[0]
